export enum UserRoleEnum {
    MANAGER = "MANAGER",
    CONSULTANT = "CONSULTANT",
  GROUP_CONSULTANT = "GROUP_CONSULTANT",
    TOWER = "TOWER",
    PARTNERSHIP = "PARTNERSHIP",
  }